import { lazy } from 'react';

import Loadable from 'components/Loadable';

const Home = Loadable(lazy(() => import('modules/home')));

export const route = { index: true, element: <Home /> };
